export const featureColumnOne = [
  {
    title: "Compose with AI",
    body: "Go from idea to layout in seconds. Generate full email structures or write sections with AI, then tweak everything visually.",
  },
  {
    title: "Reusable components",
    body: "Build your own components once, reuse them across projects. Create consistent, scalable email systems without rebuilding the same sections every time.",
  },
  {
    title: "Real-time comments",
    body: "Design together with your team. See changes instantly, leave comments, and move from feedback to final without back-and-forth.",
  },
  {
    title: "Accessibility checks",
    body: "Automatically detect accessibility issues and improve readability before you send. Helps your emails work for more people without extra effort.",
  },
];

export const featureColumnTwo = [
  {
    title: "Design without constraints",
    body: "Full control over layout, spacing, typography, and components. Build production-ready emails in Figma-like visual freedom.",
  },
  {
    title: "Drag controls",
    body: "Optimize every image for email. Automatically compress assets or fine-tune file type and quality to balance performance and visual fidelity.",
  },
  {
    title: "Email validation",
    body: "Catch render issues before you send. Get a clear preview of how key clients handle your email and fix problem areas early.",
  },
  {
    title: "Link tracking",
    body: "Add tracking where it matters. Apply UTM parameters and custom attributes to links so you can measure performance and campaign impact.",
  },
  {
    title: "Outlook ready (VML included)",
    body: "Modern design, even in legacy clients. Rounded buttons, backgrounds, and visual details render properly in Outlook with VML fallback automatically.",
  },
  {
    title: "Interactive components",
    body: "Add richer experiences with safe fallbacks. Use expandable sections, tabs, and other advanced patterns that degrade gracefully where unsupported.",
  },
];

export const faqItems = [
  {
    id: "faq-1",
    question: "How is this different from traditional email builders?",
    answer:
      "Email Perfect gives you visual freedom and production-safe output in one place. You can design with precision and still ship clean code that holds up across clients.",
  },
  {
    id: "faq-2",
    question: "Will my emails work in all email clients?",
    answer:
      "Templates are built for broad compatibility, including Outlook fallbacks. We also provide validation support so you can catch risky patterns before sending.",
  },
  {
    id: "faq-3",
    question: "Can I make responsive emails?",
    answer:
      "Yes. You can control responsive stacking, spacing, typography, and component behavior so your email adapts across desktop and mobile clients.",
  },
  {
    id: "faq-4",
    question: "Can I track link clickthroughs?",
    answer:
      "Yes. You can add tracking attributes and UTM parameters directly in the editor so analytics tools can attribute campaign performance accurately.",
  },
  {
    id: "faq-5",
    question: "Do I need to know how to code?",
    answer:
      "No coding is required for normal workflows. Designers and marketers can build complete emails visually and still export robust HTML.",
  },
  {
    id: "faq-6",
    question: "Can I export and use the HTML anywhere?",
    answer:
      "Yes. You can export clean HTML and use it in your preferred ESP or workflow. The output is designed to be portable and production-ready.",
  },
];
